import toastr from 'toastr'

import {
    ERROR
} from '../redux/root'
import { notify } from '../util/notify'

const E_DEFAULT = -1
const E_NOT_SIGNED_IN = -2
const E_BAD_CREDENTIALS = -3
const E_LOCKED = -4
const E_NO_ACCESS = -5
const E_NO_EXIST = -6
const E_ALERT = -7
export const E_MAINTENANCE = -8
export const E_NO_CONNECTION = -9
const E_DATABASE_LOCKED = -10

function processError(err, notifyEnabled) {
    if (err && 'error' in err && 'code' in err.error && err.error.code == E_NO_EXIST) {
      window.location = '/not-found'
      return
    }

    const notifier = notifyEnabled ? notify : toastr

    let msg
    if (err && 'error' in err && 'msg' in err.error) {
      msg = err.error.msg
    } else {
      msg = typeof(err) == 'object' ? "An error occurred. Please try again later." : err
    }

    if (err && err.error && (err.error.code == E_MAINTENANCE || err.error.code == E_NO_ACCESS || err.error.code == E_NOT_SIGNED_IN || err.error.code == E_NO_CONNECTION)) {
      if (err.error.code == E_MAINTENANCE) {
        notifier.info(msg, undefined, {timeOut: 0, extendedTimeout: 0, preventDuplicates: true})
      }

      if (err.error.code == E_NO_CONNECTION) {
        notifier.warning(msg)
      }

      if (err.error.code == E_NO_ACCESS || err.error.code == E_NOT_SIGNED_IN) {
        window.location = '/'
      }
    } else if (err && err.error && err.error.code == E_ALERT) {
      alert(msg)
    } else {
      notifier.error(msg)
    }
}

export const notifyErrorMiddleware = () => next => action => {
  if (action.type === ERROR) {
    processError(action.payload, true);
  }
  try {
    return next(action)
  } catch (err) {
    processError(err, true)
    throw err
  }
}

const errorMiddleware = () => next => action => {
  if (action.type === ERROR) {
    processError(action.payload, false);
  }
  try {
    return next(action)
  } catch (err) {
    processError(err, false)
    throw err
  }
}

export default errorMiddleware
